const formatCount = (value) =>
    new Intl.NumberFormat().format(value);

const findCounter = (input) => {
    const container =
        input.parentElement?.parentElement
        ?? input.parentElement;

    return container?.querySelector(
        '[data-character-count]'
    );
};

const updateCounter = (input) => {
    const counter =
        findCounter(input);

    if (! counter) {
        return;
    }

    const max =
        Number(input.maxLength);

    const current =
        input.value.length;

    counter.textContent =
        `${formatCount(current)} / ${formatCount(max)}`;

    counter.classList.toggle(
        'text-amber-600',
        max > 0
        && current >= max * 0.9
        && current < max
    );

    counter.classList.toggle(
        'text-rose-600',
        max > 0
        && current >= max
    );
};

const makeFileList = (files) => {
    const transfer =
        new DataTransfer();

    files.forEach(
        (file) =>
            transfer.items.add(file)
    );

    return transfer.files;
};

const revokePreviewUrls = (preview) => {
    preview
        .querySelectorAll(
            '[data-community-object-url]'
        )
        .forEach((element) => {
            const url =
                element.dataset
                    .communityObjectUrl;

            if (url) {
                URL.revokeObjectURL(url);
            }
        });
};

const renderPreviews = (input) => {
    const form =
        input.closest(
            '[data-community-discussion-form]'
        );

    const preview =
        form?.querySelector(
            '[data-community-attachment-preview]'
        );

    if (! preview) {
        return;
    }

    revokePreviewUrls(preview);
    preview.replaceChildren();

    const files =
        Array.from(
            input.files ?? []
        );

    preview.classList.toggle(
        'hidden',
        files.length === 0
    );

    preview.classList.toggle(
        'grid',
        files.length > 0
    );

    files.forEach(
        (file, index) => {
            const card =
                document.createElement('div');

            card.className =
                'overflow-hidden rounded-xl border border-zinc-200 bg-zinc-50 dark:border-white/10 dark:bg-white/5';

            const media =
                document.createElement(
                    file.type.startsWith('video/')
                        ? 'video'
                        : 'img'
                );

            const objectUrl =
                URL.createObjectURL(file);

            media.dataset
                .communityObjectUrl =
                    objectUrl;

            media.src =
                objectUrl;

            media.className =
                'h-28 w-full object-cover';

            if (
                media.tagName
                === 'VIDEO'
            ) {
                media.muted = true;
                media.playsInline = true;
            }

            const footer =
                document.createElement('div');

            footer.className =
                'flex items-center gap-2 px-2.5 py-2';

            const name =
                document.createElement('span');

            name.className =
                'min-w-0 flex-1 truncate text-[11px] font-semibold text-zinc-600 dark:text-zinc-300';

            name.textContent =
                file.name;

            const remove =
                document.createElement('button');

            remove.type =
                'button';

            remove.className =
                'shrink-0 rounded-lg bg-rose-50 px-2 py-1 text-[10px] font-black text-rose-700 hover:bg-rose-100 dark:bg-rose-400/10 dark:text-rose-200';

            remove.textContent =
                'Remove';

            remove.addEventListener(
                'click',
                () => {
                    const remaining =
                        Array.from(
                            input.files ?? []
                        ).filter(
                            (_, fileIndex) =>
                                fileIndex !== index
                        );

                    input.files =
                        makeFileList(
                            remaining
                        );

                    input.dispatchEvent(
                        new Event(
                            'change',
                            {
                                bubbles: true,
                            }
                        )
                    );
                }
            );

            footer.append(
                name,
                remove
            );

            card.append(
                media,
                footer
            );

            preview.append(card);
        }
    );
};

const initializeCommunityDiscussionForms = () => {
    document
        .querySelectorAll(
            '[data-community-discussion-form]'
        )
        .forEach((form) => {
            form
                .querySelectorAll(
                    '[data-character-count-input]'
                )
                .forEach((input) => {
                    updateCounter(input);

                    input.addEventListener(
                        'input',
                        () =>
                            updateCounter(input)
                    );
                });

            form
                .querySelectorAll(
                    '[data-community-attachment-input]'
                )
                .forEach((input) => {
                    renderPreviews(input);

                    input.addEventListener(
                        'change',
                        () =>
                            renderPreviews(input)
                    );
                });

            form.addEventListener(
                'reset',
                () => {
                    window.setTimeout(
                        () => {
                            form
                                .querySelectorAll(
                                    '[data-character-count-input]'
                                )
                                .forEach(updateCounter);

                            form
                                .querySelectorAll(
                                    '[data-community-attachment-input]'
                                )
                                .forEach(renderPreviews);
                        },
                        0
                    );
                }
            );
        });
};

if (
    document.readyState
    === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeCommunityDiscussionForms
    );
} else {
    initializeCommunityDiscussionForms();
}
